import { render } from "./Dictionary.vue?vue&type=template&id=21cd4523"
import script from "./Dictionary.vue?vue&type=script&lang=js"
export * from "./Dictionary.vue?vue&type=script&lang=js"

import exportComponent from "/apps/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__